import i18next, { InitOptions, TFunction } from "i18next";
import Backend, { HttpBackendOptions } from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const backend: HttpBackendOptions = {
    loadPath: `/assets/locales/{{lng}}/{{ns}}.json?mkt={{lng}}`,
    crossDomain: true,
    withCredentials: false,
    customHeaders: (() => {
        return {
            "Accept-Language": i18next.language ?? "en-US",
        };
    }) as any,
    queryStringParams: { v: "1.3.5" },
};

export const initializeIntl = (
    nameSpaces: string[],
    suggestedMarket?: string,
    initOptions?: InitOptions
): Promise<TFunction> => {
    return i18next
        .use(Backend)
        .use(initReactI18next)
        .init({
            backend,
            fallbackLng: "fr-CA",
            debug: document.location.hostname === "localhost",
            ns: nameSpaces,
            defaultNS: nameSpaces[0],
            nsSeparator: ":",
            keySeparator: ".",
            lng: suggestedMarket,
            supportedLngs: false,
            saveMissing: false, //document.location.hostname === "localhost",
            returnEmptyString: true,
            load: "currentOnly",
            cleanCode: true,
            interpolation: {
                escapeValue: false,
            },
            detection: {
                order: [
                    "querystring",
                    "sessionStorage",
                    "localStorage",
                    "cookie",
                    "navigator",
                    "htmlTag",
                ],
                lookupQuerystring: "mkt",
                lookupCookie: "market",
                lookupLocalStorage: "mkt",
                lookupSessionStorage: "mkt",
                lookupFromPathIndex: 0,
                caches: ["localStorage"],
                excludeCacheFor: ["cimode"],
                htmlTag: document.documentElement,
            },
            ...initOptions,
        });
};
